class Preloader {
    constructor(sel) {
        // view
        this.component = document.querySelector(sel);
        this.videoInit = this.component.querySelector('.init-box video');
        this.overflow = document.body.style.overflow;
        this.videoEnd = this.component.querySelector('.end-box video');
        this.skipBttn = this.component.querySelector('.end-box');

        if (this.component) {

            const showOnce = this.component.classList.contains('showOnce');
            const hasShowed = this.hasCookie("hidePreload");

            if (showOnce && hasShowed) return this.component.classList.toggle('hide', true);
            this.init();
        }
    }
    init() {

        window.waitForPreload = true;
        document.body.style.overflow = 'hidden';

        this.videoInit.addEventListener("canplaythrough", () => {
            this.videoInit.play()
        });

        setTimeout(() => this.videoInit.play(), 250);

        this.videoInit.play();

        this.videoInit.addEventListener("ended", () => {
            if(this.videoEnd instanceof HTMLVideoElement) {
                this.videoEnd.loop = false;
                this.videoEnd.currentTime = 0;
                this.playEndVideo();
            }
            this.component.classList.toggle('end-first-video', true);
            
        });

        this.skipBttn.addEventListener("click", () => {
            if(this.videoEnd instanceof HTMLVideoElement) {
                this.videoEnd.pause();
            }
            
            this.component.classList.toggle('end-last-video', true);
            this.cleanOverflow();
            this.simulateResize();
        });
    }
    playEndVideo () {

        if(!(this.videoEnd instanceof HTMLVideoElement)) return;
        // PLAY SECOND VIDEO
        this.videoEnd.addEventListener("canplaythrough", () => {
            this.videoEnd.play();
        });
        setTimeout(() => this.videoEnd.play(), 250);
        this.videoEnd.play();

        // ENDED SECOND VIDEO
        this.videoEnd.addEventListener("ended", () => {
            this.component.classList.toggle('end-last-video', true);
            this.cleanOverflow();
            this.simulateResize();
        });

    }
    hasCookie = (cookie) =>
        document.cookie.split(";").some((item) => item.trim().startsWith(cookie));

    cleanOverflow() {
        document.body.style.overflow = this.overflow;
        document.cookie = "hidePreload=1; SameSite=None; Secure";
    }
    simulateResize() {
        window.dispatchEvent(new Event('resize'));
    }
}

const preloader = new Preloader(".preloader");

